import React, { useEffect, useState, useRef } from 'react';
import Header from '../Component/Header'
import Footer from '../Component/Footer'
// import AdvertisementModal from '../Component/AdvertisementModal'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../assets/css/style.css';



function Home() {
    const [services, setServices] = useState([]); // State to store services
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [videoLinks, setVideoLinks] = useState([]);
    const reelsContainerRef = useRef(null);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();

                // Transform the fetched data to match your services structure
                const transformedData = result.data.map((item) => ({
                    id: item.id,
                    name: item.category,
                    image: `${item.categoryIcon}`, // Prepend the image URL from the environment variable
                }));

                setServices(transformedData);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    const fetchVideos = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/getvideos`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const result = await res.json();
            setVideoLinks(result.videos || []);
        } catch (error) {
            console.error('Error fetching videos:', error);
        }
    };

    useEffect(() => {
        fetchVideos();
    }, []);


    const images = [
        "/img/Home/1.jpg",
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 4000);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, [images.length]);

    useEffect(() => {
        const videos = document.querySelectorAll("video");
        videos.forEach((video) => {
            video.muted = true;

            const playPromise = video.play();

            if (playPromise && typeof playPromise.then === "function") {
                playPromise
                    .then(() => { })
                    .catch((error) => console.warn("Autoplay blocked:", error));
            }
        });
    }, [videoLinks]);


    const styles = {
        slider: {
            position: "relative",
            overflow: "hidden",
            width: "99%",
            height: "calc(100vw / 2.37)",   // maintain exact ratio of your images
            maxHeight: "631px",             // optional - prevents it from becoming too tall
            margin: "0 auto",
        },
        imagesContainer: {
            display: "flex",
            transition: "transform 0.8s ease-in-out",
            transform: `translateX(-${currentIndex * 100}%)`,
        },
        image: {
            width: "100%",     // Fill entire screen width
            height: "100%",    // Fill entire screen height
            objectFit: "cover", // Crop to fill screen without distortion
            flexShrink: 0,
        },
    };

    return (
        <>
                {/* <AdvertisementModal /> */}

                    {/* 🔥 WOW FIX ADDED HERE */}
            {/* <style>{`
                .wow {
                    contain: layout style paint;
                    will-change: opacity, transform;
                }
            `}</style> */}

            <Header />
            <div style={{ height: "70px" }}></div>

            {/* Banner Section */}
            <div style={{ backgroundColor: "#FFFFFF", overflowX: "hidden" }}>
                <div className="hero-header py-5 mb-0 mt-5 mt-sm-0">
                    <Swiper
                        modules={[Autoplay]}
                        autoplay={{ delay: 4000, disableOnInteraction: false }}
                        loop={true}
                        speed={800}
                        slidesPerView={1}
                        style={{ width: "100%", height: "calc(100vw / 2.37)", maxHeight: "631px" }}
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={index}>
                                <img
                                    src={image}
                                    alt={`Slide ${index + 1}`}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                {/* About Section */}
                <div className="container-xxl py-0">
                    <div className="container">
                        <div className="row g-5">

                            {/* Text Column */}
                            <div className="col-15 col-sm-12 col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                                <div className="h-100">
                                    <p className="text-uppercase mb-2" style={{ color: "#EAA636" }}>About Us</p>
                                    <h1 className="display-6 mb-4">We Are Creative And Professional Photographer</h1>

                                    <p>
                                       For us, photography is more than clicking pictures it’s about capturing emotions that stay with you forever. From the tiny stretch of your newborn and the beautiful glow of maternity to the playful giggles of kids and the joy of a cake smash, we freeze every moment with love, patience, and a touch of magic.
                                    </p>

                                    <p>
                                        We believe every family has a unique story worth cherishing. At Maa And Me Portraits, we take the time to understand you your personality, your bond, and what makes your moments truly special. With every photograph, we aim to reflect not just how you look, but how you feel.
                                    </p>

                                    <p>
                                        Whether it’s an intimate maternity session, a fun-filled kids shoot, or a warm family portrait, we’re here to make your memories unforgettable. These are the moments you’ll look back on, smile at, and treasure for years to come and we’re honored to capture them for you.
                                    </p>
                                </div>
                            </div>

                            {/* Image Column */}
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="row g-3 img-twice position-relative h-100">

                                    {/* First Image */}
                                    <div className="col-12 col-sm-6 col-md-11 col-lg-10 col-xl-6 col-xxl-6">
                                        <img className="img-fluid p-2 p-sm-3 w-100" style={{ backgroundColor: "#f8f9fa" }} src="img/About/01.jpg" alt="Image 1" />
                                    </div>

                                    {/* Second Image */}
                                    <div className="col-12 col-sm-6 col-md-11 col-lg-10 col-xl-6 col-xxl-6 align-self-end">
                                        <img className="img-fluid p-2 p-sm-3 w-100" style={{ backgroundColor: "#f8f9fa" }} src="img/About/02.jpg" alt="Image 2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Why choose US Section */}
                <div className="container-xxl py-5">
                    <div className="container">
                        <div
                            className="text-center mx-auto wow fadeInUp"
                            data-wow-delay="0.1s"
                            style={{ maxWidth: 500 }}
                        >
                            <p className=" text-uppercase mb-2" style={{ color: "#EAA636" }}>
                                Why Choose Us!
                            </p>
                            <h1 className="display-6 mb-5">The Leading Photo Studio In The Country</h1>
                        </div>
                        <div className="row g-3">
                            <div className="col-17 col-sm-13 col-md-6 col-lg-4 col-xl-4 col-xxl-4 pt-4 pt-lg-5 wow fadeInUp" data-wow-delay="0.1s">
                                <div
                                    className="fact-item text-center h-100 p-5"
                                    style={{
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        border: '1px solid #ccc',
                                        borderRadius: '12px',
                                        backgroundColor: '#f8f9fa',
                                    }}
                                >
                                    <h1 className="display-2 text-primary mb-3" data-toggle="counter-up">5</h1>
                                    <h4 className="mb-3">Award-Winning</h4>
                                    <span>
                                        We don’t just take pictures; we create stories that win hearts.
                                        Our award-winning photography showcases the passion, creativity, and care we put into every shoot.
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                                <div
                                    className="fact-item text-center h-100 p-5"
                                    style={{
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        border: '1px solid #ccc',
                                        borderRadius: '12px',
                                        backgroundColor: '#f8f9fa',
                                    }}
                                >
                                    <h1 className="display-2 text-primary mb-3" data-toggle="counter-up">8+</h1>
                                    <h4 className="mb-3">Years of Experience</h4>
                                    <span>
                                        We've mastered the art of capturing life’s most beautiful moments.
                                        From maternity to Family sessions, we know how to make every shot count.
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 pt-lg-5 wow fadeInUp" data-wow-delay="0.5s">
                                <div
                                    className="fact-item text-center h-100 p-5"
                                    style={{
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        border: '1px solid #ccc',
                                        borderRadius: '12px',
                                        backgroundColor: '#f8f9fa',
                                    }}
                                >
                                    <h1 className="display-2 text-primary mb-3" data-toggle="counter-up">10,000+</h1>
                                    <h4 className="mb-3">Happy Clients</h4>
                                    <span>
                                        Our clients are at the heart of everything we do.
                                        Thousands of happy smiles, laughter, and memories later,
                                        we’re proud to have been part of so many incredible stories.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            {/* About Owner Section */}
            <div
    className="container-xxl"
    style={{
        paddingTop: "90px",      // 👈 Change top gap here
        paddingBottom: "60px",   // 👈 Change bottom gap here
    }}
>
                <div className="container">
                    <div className="row g-5">

                        {/* Image Column (Left) */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <img
                                    className="img-fluid"
                                    src="/img/About/about.webp"  // <-- Change owner image path here
                                    alt="Owner"
                                    style={{
                                        width: "100%",          // Editable
                                        height: "600px",        // Editable
                                        objectFit: "cover",
                                        borderRadius: "12px",
                                        backgroundColor: "#f8f9fa"
                                    }}
                                />
                            </div>
                        </div>

                        {/* Text Column (Right) */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="h-100">
                                <p className="text-uppercase mb-2" style={{ color: "#000000ff" }}>Meet the Photographer Behind the Brand</p>
                                <h1 className="display-6 mb-4">Axita Pandey</h1>

                                <p>
                                    the creative heart behind Maa And Me Portraits, is a passionate newborn, maternity, kids, family, and portrait photographer dedicated to preserving life's most precious milestones. With years of experience in capturing genuine emotions and meaningful family moments, she transforms every session into a beautiful storytelling experience, creating timeless photographs that families will cherish for generations.
                                </p>

                                <p>
                                    Known for her warm, patient, and comforting approach, Axita has a natural ability to make every family feel relaxed and at ease in front of the camera. Whether it's the delicate innocence of a newborn, the radiant glow of an expecting mother, the joyful laughter of children, or the togetherness of a family portrait, she carefully captures authentic emotions with creativity, elegance, and attention to every detail. Every photograph reflects not just how the moment looked, but how it truly felt.
                                </p>

                                <p>
                                     Over the years, Axita has had the privilege of documenting countless beautiful family journeys, earning the trust of parents through her professionalism, artistic vision, and genuine passion for photography. Every session is thoughtfully planned to provide a comfortable, memorable experience, resulting in heartfelt images that celebrate love, connection, and the unforgettable moments that make every family's story unique.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


                {/* Service Section */}
                <div className="container-xxl bg-white py-4 mb-3">
                    <div
                        className="text-center mx-auto mb-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{ maxWidth: 500 }}
                    >
                        <p className="text-primary text-uppercase mb-2">Our Services</p>
                        <h1 className="display-6 mb-4">We Provide Best Professional Services</h1>
                    </div>

                    {loading && <p className="text-center">Loading services...</p>}
                    {error && <p className="text-center text-danger">{error}</p>}

                    {!loading && !error && (
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            navigation
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            speed={1000}
                            breakpoints={{
                                0: { slidesPerView: 1, spaceBetween: 10 },
                                576: { slidesPerView: 2, spaceBetween: 15 },
                                768: { slidesPerView: 3, spaceBetween: 20 },
                                992: { slidesPerView: 4, spaceBetween: 30 },
                            }}
                            style={{ paddingBottom: '40px' }}
                            observer={false}
                            observeParents={false}
                            observeSlideChildren={false}
                        >
                            {services.map((service) => (
                                <SwiperSlide key={service.id} style={{ width: 'auto' }}>
                                    <div className="hover-zoom">
                                        <Link
                                            to={`/service/${service.id}/${service.name}`}
                                            className="text-decoration-none text-dark"
                                        >
                                            <div
                                                className="service-item d-flex flex-column p-3 pb-0"
                                                style={{
                                                    minWidth: '250px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '12px',
                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                                    overflow: 'hidden',
                                                    transition: 'transform 0.3s ease-in-out',
                                                    backgroundColor: '#f8f9fa',
                                                }}
                                            >
                                                <div
                                                    className="position-relative"
                                                    style={{ height: '350px', overflow: 'hidden' }}
                                                >
                                                    <img
                                                        className="img-fluid"
                                                        src={service.image}
                                                        alt={service.name}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            transition: 'transform 0.3s ease-in-out',
                                                        }}
                                                    />
                                                </div>
                                                <div className="text-center p-4">
                                                    <h4>{service.name}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                </div>

                {/* Reels Section */}
                <div className="container-xxl bg-white py-4 mb-3 reels-wrapper">
                    <div
                        className="text-center mx-auto mb-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{ maxWidth: 500 }}
                    >
                        <p className="text-primary text-uppercase mb-2">Our Video</p>
                        <h2 className="display-6 mb-4">Watch Our Work</h2>
                    </div>

                    <Swiper
                        modules={[Navigation, Autoplay]}
                        spaceBetween={20}
                        navigation // ✅ This enables default Swiper arrows
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        speed={1000}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            576: { slidesPerView: 2 },
                            768: { slidesPerView: 3 },
                            992: { slidesPerView: 4 },
                        }}
                        style={{ paddingBottom: '40px' }}
                    >
                        {videoLinks.map((video, index) => (
                            <SwiperSlide key={index}>
                                <div className="reel-box" style={{
                                    width: '100%',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: '#f8f9fa',
                                    padding: '10px'
                                }}>
                                    <video
                                        src={video.video_link}
                                        preload="auto"
                                        autoPlay
                                        muted
                                        playsInline
                                        controls
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: '10px',
                                        }}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>


                {/* Testimonial Start */}
                <div className="container-xxl py-5">
                    <div className="container">
                        <div className="text-center mx-auto mb-5" style={{ maxWidth: 500 }}>
                            <p className="text-uppercase mb-2" style={{ color: "#EAA636" }}>
                                Client's Review
                            </p>
                            <h1 className="display-6 mb-0">More Than 50+ Customers Trusted Us</h1>
                        </div>

                        <div className="row">
                            {/* Google Summary Box */}
                            <div className="col-12 col-md-4 mb-4 text-center d-flex flex-column justify-content-center align-items-center">
                                <h4 className="fw-bold">EXCELLENT</h4>
                                <div className="mb-2">
                                    <i className="fas fa-star text-warning fs-4 me-1"></i>
                                    <i className="fas fa-star text-warning fs-4 me-1"></i>
                                    <i className="fas fa-star text-warning fs-4 me-1"></i>
                                    <i className="fas fa-star text-warning fs-4 me-1"></i>
                                    <i className="fas fa-star text-warning fs-4"></i>
                                </div>
                                <p className="mb-1 fw-medium">Based on 100 reviews</p>
                                <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                                    alt="Google"
                                    style={{ height: "40px" }}
                                />
                            </div>

                            {/* Swiper Slider */}
                            <div className="col-12 col-md-8">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    navigation
                                    spaceBetween={8}
                                    slidesPerView={2}
                                    breakpoints={{
                                        0: { slidesPerView: 1 },
                                        768: { slidesPerView: 2 },
                                    }}
                                    autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                        pauseOnMouseEnter: true,
                                    }}
                                >
                                    {[
                                        {
                                            name: "Vidhi Patel",
                                            text: "I highly recommend the work of photographer Anilbhai & Team, They have numerous packages for baby shoot, maternity shoot, and product photography etc.",
                                            id: 1,
                                        },
                                        {
                                            name: "Nidhi Mishra",
                                            text: "Excellence in every aspect. Thank you Anil ji for capturing so beautiful and memorable moments for us... Maa And Me Portraits is actually a perfect hub",
                                            id: 2,
                                        },
                                        {
                                            name: "Parth Patel",
                                            text: "Great work. The staff is very co-operative and supporting. Creative photography and outfits and makeup artist are awesome. Such a great experience.",
                                            id: 3,
                                        },
                                        {
                                            name: "Amit Jain",
                                            text: "This was our first project here.. Very professional and talented photographer.. studio setup and costumes are fantastic.. very helpful and cooperative.",
                                            id: 4,
                                        },
                                        {
                                            name: "Tithi Mashiyawa",
                                            text: "Photoshoot was really good and they have really good themes for babby photoshoot I really loved their work and staff is really nice and humble",
                                            id: 5,
                                        },
                                        {
                                            name: "Anand Barot",
                                            text: "Maa And Me Portraits Captures the memories, photographer is talented, professional, and dedicated towards their work, I can say its Professionally captured perfect click.",
                                            id: 6,
                                        },
                                    ].map((review) => (
                                        <SwiperSlide key={review.id}>
                                            <div className="testimonial-item p-4 h-100" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)', border: '1px solid #ccc', borderRadius: '12px', backgroundColor: '#f8f9fa', }} >
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5 className="mb-0">{review.name}</h5>
                                                    <img
                                                        src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                                                        alt="Google"
                                                        style={{ height: "40px" }}
                                                    />
                                                </div>
                                                <div className="mb-2">
                                                    <i className="fas fa-star text-warning me-1"></i>
                                                    <i className="fas fa-star text-warning me-1"></i>
                                                    <i className="fas fa-star text-warning me-1"></i>
                                                    <i className="fas fa-star text-warning me-1"></i>
                                                    <i className="fas fa-star text-warning"></i>
                                                </div>
                                                <p className="mb-0">{review.text}</p>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )

}

export default Home
